export default __webpack_public_path__ + "static/media/image-artist-1.536aace1.jpg";